<template>
  <list-view-cell
    class="scheduled-crew-cell"
    :context-menu-items="contextMenuItems"
  >
    <p>
      <span class="mr-2" v-if="crew_id">Crew {{ crew_id }}:</span>
      <span v-if="name">{{ name }}</span>
    </p>
    <p class="scheduled-for">
      Scheduled: {{ scheduled_for | moment("hh:mm a") }}
    </p>
    <p v-if="estimated_hours">{{ estimated_hours }} hours</p>
    <template v-if="customer">
      <p v-if="customer.name">{{ customer.name }}</p>
      <template v-if="customer.places && customer.places.length">
        <p>{{ customer.places[0].address_1 }}</p>
        <p>
          {{ customer.places[0].cityStateZip }}
          <a
            class="ml-1 text-red hover-bold"
            :href="generateGoogleMapsUrl(customer.places[0])"
          >
            <i class="fal fa-map-marker-alt"></i>
          </a>
        </p>
      </template>
    </template>
  </list-view-cell>
</template>

<script>
import ListViewCell from "../ListViewCell";
import { Contact } from "../../../../models/Contact";
import { ContextMenuItem } from "../../../../helper-classes/ContextMenuItem";
import { Contract } from "../../../../models/Contract";

export default {
  name: "ScheduledCrewCell",
  components: { ListViewCell },
  props: {
    crew_id: [String, Number],
    name: String,
    scheduled_for: Date,
    estimated_hours: Number,
    contract: Contract,
    customer: Contact
  },
  data() {
    return {
      contextMenuItems: [
        new ContextMenuItem("View Contract", () => {
          this.$router.push({
            name: "contracts-show",
            params: { id: this.contract.id }
          });
        }),
        new ContextMenuItem("View Project", () => {
          console.log("View Project");
        })
      ]
    };
  }
};
</script>
